import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  UncontrolledTooltip,
} from "reactstrap";
import Select from "react-select";
import { Link } from "react-router-dom";
import TableContainer from "../../../../components/Common/TableContainer";
import Breadcrumbs from "../../../../components/Common/Breadcrumb";
import { useFormik } from "formik";
import * as Yup from "yup";
import CustomSelect from "components/Common/custom-select";
import CustomDatePicker from "common/CustomDatePicker";
import { genderOptions } from "common/data/constants";
import { useDispatch, useSelector } from "react-redux";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import Loader from "common/pageLoader";
import { changeRequisitionStatusRequest, fetchCategories, fetchDepartments, fetchDesignations, fetchEmployeeDropdownAutoList, fetchPositionsByDeptRole, fetchRecruitmentRequisition, fetchRoles, saveRecruitmentRequisition } from "store/actions";
import Swal from "sweetalert2";
import { convertToInputDate, formatDate } from "common/dateFormat/formatDate";


const levelOptions = [
  { value: 1, label: "Experience" },
  { value: 2, label: "Fresher" },
];

const purposeOptions = [
  { value: 1, label: "New Position" },
  { value: 2, label: "Replacement" },
];

const jobTypeOptions = [
  { value: 1, label: "Full Time" },
  { value: 2, label: "Part Time" },
  { value: 3, label: "Contract" },
];

const Requisition = () => {
  const dispatch = useDispatch();
  const [authDetails, setAuthDetails] = useState(null);
  const {
    departments, 
    designations,
    filteredPositions,
    requisitions,
    dropdownAutoList,
    loading,
    success,
    error,
  } = useSelector((state) => ({
    departments: state.DepartmentMaster?.departments ?? [],
    designations: state.DesignationMaster?.designations ?? [],
    filteredPositions: state.JobSetupPositionSkillReducer?.filteredPositions ?? [],
    requisitions: state.RecruitmentRequistionReducer?.requisitions ?? [],
    dropdownAutoList: state.EmployeeDetailsReducer?.dropdownAutoList,

    loading: state.EmployeeDetailsReducer?.loading || state.RecruitmentRequistionReducer?.loading || state.DepartmentMaster?.loading  || state.DesignationMaster?.loading || state.JobSetupPositionSkillReducer?.loading ,
    error: state.EmployeeDetailsReducer?.loading || state.RecruitmentRequistionReducer?.error || state.DepartmentMaster?.error  || state.DesignationMaster?.error|| state.JobSetupPositionSkillReducer?.error ,
    success: state.RecruitmentRequistionReducer?.success,
  }));

  useEffect(() => {
    const authUserDetails = useAuthUserDetails();
    setAuthDetails(authUserDetails[0])
    const unitId = authUserDetails[0].unit_id
    dispatch(fetchRoles(unitId));
    dispatch(fetchDepartments(unitId));
    dispatch(fetchDesignations(unitId));
    dispatch(fetchRecruitmentRequisition(unitId))
    dispatch(fetchEmployeeDropdownAutoList(unitId))
  }, [dispatch]);

  useEffect(() => {
    if (success) {
      dispatch(fetchRecruitmentRequisition(authDetails?.unit_id))
      formik.resetForm();
      setIsEdit(false);
      setEditId(null);
    }
  }, [authDetails, success, dispatch]);

  const [isEdit, setIsEdit] = useState(false);
  const [editId, setEditId] = useState(null);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      department: null,
      role: null,
      position: null,
      resource: null,
      purpose: null,
      replacementOf:"",
      gender: null,
      level: null,
      yearsFrom: "",
      yearsTo: "",
      joinDate: null,
      jobType: null,
      remarks: "",
    },
    validationSchema: Yup.object({
      department: Yup.object().nullable().required("Department is required"),
      role: Yup.object().nullable().required("Role is required"),
      position: Yup.object().nullable().required("Position is required"),
      resource: Yup.number().nullable().required("Number of resources required"),
      purpose: Yup.object().nullable().required("Purpose is required"),
      level: Yup.object().nullable().required("Level is required"),
      // yearsFrom: Yup.number()
      //   .required('Years range is required')
      //   .min(0, 'Years must be 0 or greater'),
      // yearsTo: Yup.number()
      //   .required('Years range is required')
      //   .moreThan(Yup.ref('yearsFrom'), 'To year must be greater than From year')
      //   .test(
      //     'is-greater',
      //     'To year must be greater than or equal to From year',
      //     function (value) {
      //       const { yearsFrom } = this.parent;
      //       return value >= yearsFrom;
      //     }
      //   ),
      joinDate: Yup.date().nullable().required("Join date is required"),
      jobType: Yup.object().nullable().required("Job type is required"),
      // remarks: Yup.string().required("Remarks are required"),
      gender: Yup.object().nullable().required("Gender is required"),

    }),
    onSubmit: (values, { resetForm }) => {
      const formData = new FormData();

      formData.append('req_id', isEdit ? editId : 0);
      formData.append('dept_id', values.department?.value || '');
      formData.append('role_id', values.role?.value || '');
      formData.append('position_id', values.position?.value || '');
      formData.append('resource_count', values.resource || '');
      formData.append('purpose_id', values.purpose?.value || '');
      formData.append('remarks', values.remarks || '');
      formData.append('replacementof', values.replacementOf && values.replacementOf.length ? values.replacementOf.map(item => item.value).join(",") : '0');
      formData.append('gender_id', values.gender?.value || '');
      formData.append('join_date', values.joinDate || '');
      formData.append('exp_level_id', values.level?.value || '');
      formData.append('years_from', values.yearsFrom || 0);
      formData.append('years_to', values.yearsTo || 0);
      formData.append('jobtype_id', values.jobType?.value || '');
      formData.append('unit_id', authDetails?.unit_id || '');
      formData.append('create_by', authDetails?.user_id || '');
      dispatch(saveRecruitmentRequisition(formData))
    },
  });

  const handleEdit = (row) => {
    setIsEdit(true);
    setEditId(row.req_id); // Use req_id from response
  // Split the comma-separated strings into arrays
  const replacementIds = row.replacement_of_id?.split(",") || [];
  const replacementNames = row.replacement_of_name?.split(",") || [];

  // Combine into label/value objects
  const replacementOptions = replacementIds.map((id, index) => ({
    value: id.trim(),
    label: replacementNames[index]?.trim() || "",
  }));
    formik.setValues({
      department: { label: row.department, value: row.dept_id },
      role: { label: row.role, value: row.role_id },
      position: { label: row.position, value: row.position_id },
      resource: row.no_of_resource,
      purpose: { label: row.purpose, value: row.purpose_id },
      gender: { label: row.gender, value: row.gender_id },
      level: { label: row.emp_level, value: row.emp_level_id },
      yearsFrom: parseInt(row.exp_from) || "",
      yearsTo: parseInt(row.exp_to) || "",
      joinDate: convertToInputDate(row.join_dt) || "",
      jobType: { label: row.job_type_name, value: row.job_type },
      remarks: row.remarks || "",
      replacementOf: replacementOptions,
    });
  };


  const columns = [
    {
      Header: "S.No",
      Cell: ({ row }) => requisitions.length - row.index,
      className: "serial-no",
      applyHeaderClass: true,
    },
    {
      Header: "Action",
      Cell: (cellProps) => {
        const { b_active, req_id } = cellProps.row.original;
        const isActive = b_active === 1; // Status 1 = Active
        return (
          <div className="d-flex gap-3">
            <Link
              to="#"
              className="text-success"
              onClick={() => handleEdit(cellProps.row.original)}
            >
              <i className="bx bxs-edit font-size-18" id={`edittooltip${req_id}`} />
              <UncontrolledTooltip placement="top" target={`edittooltip${req_id}`}>
                Edit
              </UncontrolledTooltip>
            </Link>
            <Link
              to="#"
              style={{ color: isActive ? "green" : "red" }}
              onClick={() => handleToggleStatus(req_id, isActive)}
            >
              <i
                className={`mdi ${isActive ? "mdi-check-circle" : "mdi-close-circle"} font-size-18`}
                id={`status-tooltip-${req_id}`}
              />
              <UncontrolledTooltip placement="top" target={`status-tooltip-${req_id}`}>
                {isActive ? "Mark Inactive" : "Mark Active"}
              </UncontrolledTooltip>
            </Link>
          </div>
        );
      },
    },
    { Header: "Department", accessor: "department" },
    { Header: "Role", accessor: "role" },
    { Header: "Position", accessor: "position" },
    { Header: "No of Resource", accessor: "no_of_resource" },
    { Header: "Purpose", accessor: "purpose" },
    { Header: "Replacement Of", accessor: "replacement_of_name" },
    { Header: "Gender", accessor: "gender" },
    { Header: "Level", accessor: "emp_level" },
    // { Header: "Years From", accessor: "exp_from" },
    // { Header: "Years To", accessor: "exp_to" },
    // { Header: "Job Type", accessor: "job_type_name" },
    // { Header: "Remarks", accessor: "remarks" },
    {
      Header: "Status",
      accessor: "status",
      Cell: ({ value }) => {
        let badgeClass = "bg-secondary"; // default

        if (value === "Pending") badgeClass = "bg-warning";
        else if (value === "Approved") badgeClass = "bg-success";
        else if (value === "Rejected") badgeClass = "bg-danger";
        else if (value === "In Progress") badgeClass = "bg-info";

        return (
          <span className={`badge ${badgeClass} font-size-12`}>
            {value}
          </span>
        );
      },
    },
    { Header: "Remarks", accessor: "req_remarks" },
  ];


  const handleToggleStatus = (id, isActive) => {
    Swal.fire({
      title: 'Are you sure?',
      text: `You are about to ${isActive ? 'deactivate' : 'activate'} this.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Cancel',
      reverseButtons: false,
      dangerMode: true,
    }).then((result) => {
      if (result.isConfirmed) {
        const formData = new FormData();
        formData.append("req_id", id);
        formData.append("unit_id", authDetails?.unit_id);
        formData.append("created_by", authDetails?.user_id);
        dispatch(changeRequisitionStatusRequest(formData));
      }
    });
  };


  const SelectcustomStyles = {
    control: (base) => ({
      ...base,
      maxheight: 33.1,
      minHeight: 33.1,
      // overflow: "scroll",
    }),
    indicatorsContainer: (base) => ({
      ...base,
      padding: "0", // Match the padding for both dropdown and clear indicator
    }),
    dropdownIndicator: (base) => ({
      ...base,
      padding: "2px 8px", // Ensure consistent padding for dropdown indicator
    }),
    clearIndicator: (base) => ({
      ...base,
      padding: "2px 8px", // Adjust padding for clear indicator to match dropdown
    }),
  };

  return (
    <div className="page-content">
      <Loader loading={loading} />
      <Container fluid>
        <Breadcrumbs
          title="Resource"
          breadcrumbItem="Man Power Requistion"
        />

        <Card>
          <CardBody>
            <Form onSubmit={formik.handleSubmit}>
              <Row className=" mb-3">
                <Col md={3}>
                  <FormGroup>
                    <Label>Department <span className="text-danger">*</span></Label>
                    <CustomSelect
                      id="department"
                      name="department"
                      options={departments.map(cat => ({ value: cat.departmentId.toString(), label: cat.departmentname }))}
                      value={formik.values.department || null}  // Store full object
                      onChange={selectedOption => {
                        formik.setFieldValue("department", selectedOption);
                        formik.setFieldValue("position", null);
                        const selectedRole = formik.values.role;
                        if (selectedOption?.value && selectedRole?.value) {
                          dispatch(fetchPositionsByDeptRole(selectedOption.value, selectedRole.value, authDetails?.unit_id));
                        }
                      }}
                      onBlur={formik.handleBlur}
                      className={formik.touched.department && formik.errors.department ? 'is-invalid' : ''}
                    />
                    {formik.touched.department && formik.errors.department && (
                      <div className="text-danger ">
                        {formik.errors.department}
                      </div>
                    )}
                  </FormGroup>
                </Col>

                <Col md={3}>
                  <FormGroup>
                    <Label>Role <span className="text-danger">*</span></Label>
                    <CustomSelect
                      id="role"
                      name="role"
                      options={designations.map(cat => ({ value: cat.desig_id.toString(), label: cat.designation }))}
                      value={formik.values.role || null}  // Store full object
                      onChange={selectedOption => {
                        formik.setFieldValue("role", selectedOption);
                        formik.setFieldValue("position", null);
                        const selectedDept = formik.values.department;
                        if (selectedDept?.value && selectedOption?.value) {
                          dispatch(fetchPositionsByDeptRole(selectedDept.value, selectedOption.value, authDetails?.unit_id));
                        }
                      }}
                      onBlur={formik.handleBlur}
                      className={formik.touched.role && formik.errors.role ? 'is-invalid' : ''}
                    />
                    {formik.touched.role && formik.errors.role && (
                      <div className="text-danger ">
                        {formik.errors.role}
                      </div>
                    )}
                  </FormGroup>
                </Col>

                <Col md={3}>
                  <FormGroup>
                    <Label>Position <span className="text-danger">*</span></Label>
                    <CustomSelect
                      id="position"
                      name="position"
                      options={filteredPositions.map(emp => ({ value: emp.mpos_id, label: emp.pos }))}
                      value={formik.values.position || null}  // Store full object
                      onChange={(selectedOption) => formik.setFieldValue("position", selectedOption)}
                      onBlur={formik.handleBlur}
                      className={formik.touched.position && formik.errors.position ? 'is-invalid' : ''}
                    />
                    {formik.touched.position && formik.errors.position && (
                      <div className="text-danger ">
                        {formik.errors.position}
                      </div>
                    )}
                  </FormGroup>
                </Col>

                <Col md={3}>
                  <FormGroup>
                    <Label>No of Resource <span className="text-danger">*</span></Label>
                    <Input
                      type="number"
                      name="resource"
                      value={formik.values.resource}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}

                    />
                    {formik.touched.resource && formik.errors.resource && (
                      <div className="text-danger ">
                        {formik.errors.resource}
                      </div>
                    )}
                  </FormGroup>
                </Col>

                <Col md={3}>
                  <FormGroup>
                    <Label>Purpose <span className="text-danger">*</span></Label>
                    <CustomSelect
                      id="purpose"
                      name="purpose"
                      options={purposeOptions}
                      value={formik.values.purpose || null}  // Store full object
                      onChange={(selectedOption) => formik.setFieldValue("purpose", selectedOption)}
                      onBlur={formik.handleBlur}
                      className={formik.touched.purpose && formik.errors.purpose ? 'is-invalid' : ''}
                    />
                    {formik.touched.purpose && formik.errors.purpose && (
                      <div className="text-danger ">
                        {formik.errors.purpose}
                      </div>
                    )}
                  </FormGroup>
                </Col>
                {formik.values.purpose?.value === 2 ? (
                <Col md={3}>
                  <FormGroup>
                    <Label>Replacement of <span className="text-danger">*</span></Label>
                    <CustomSelect
                      id="replacementOf"
                      name="replacementOf"
                      options={dropdownAutoList.map(cat => ({ value: cat.emp_id.toString(), label: cat.emp_no }))}
                      value={formik.values.replacementOf || null}  // Store full object
                      onChange={(selectedOption) => formik.setFieldValue("replacementOf", selectedOption)}
                      onBlur={formik.handleBlur}
                      className={formik.touched.replacementOf && formik.errors.replacementOf ? 'is-invalid' : ''}
                      isMulti
                    />
                    {formik.touched.replacementOf && formik.errors.replacementOf && (
                      <div className="text-danger ">
                        {formik.errors.replacementOf}
                      </div>
                    )}
                  </FormGroup>
                </Col>
                ):(
                  <Col md={3}>
                  <FormGroup>
                    <Label>Remarks <span className="text-danger">*</span></Label>
                    <Input
                      type="textarea"
                      name="remarks"
                      value={formik.values.remarks}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      style={{ maxHeight: "33.1px", minHeight: "33.1px" }}
                    />
                    {formik.touched.remarks && formik.errors.remarks && (
                      <div className="text-danger ">
                        {formik.errors.remarks}
                      </div>
                    )}
                  </FormGroup>
                </Col>
                )}
                <Col md={3}>
                  <FormGroup>
                    <Label>Gender <span className="text-danger">*</span></Label>
                    <CustomSelect
                      id="gender"
                      name="gender"
                      options={genderOptions}
                      value={formik.values.gender || null}  // Store full object
                      onChange={(selectedOption) => formik.setFieldValue("gender", selectedOption)}
                      onBlur={formik.handleBlur}
                      className={formik.touched.gender && formik.errors.gender ? 'is-invalid' : ''}
                    />
                    {formik.touched.gender && formik.errors.gender && (
                      <div className="text-danger ">
                        {formik.errors.gender}
                      </div>
                    )}
                  </FormGroup>
                </Col>

                <Col md={3}>
                  <FormGroup>
                    <Label>Expected Join Date <span className="text-danger">*</span></Label>
                    <CustomDatePicker
                        name="joinDate"
                        value={formik.values.joinDate}
                        onChange={(date) => formik.setFieldValue("joinDate", date)}
                        onBlur={formik.handleBlur}
                        className={`form-control ${formik.touched.joinDate && formik.errors.joinDate ? "is-invalid" : ""}`}
                      />
                    {formik.touched.joinDate && formik.errors.joinDate && (
                      <div className="text-danger ">
                        {formik.errors.joinDate}
                      </div>
                    )}
                  </FormGroup>
                </Col>

                <Col md={3}>
                  <FormGroup>
                    <Label>Job Type <span className="text-danger">*</span></Label>
                    <CustomSelect
                      id="jobType"
                      name="jobType"
                      options={jobTypeOptions}
                      value={formik.values.jobType || null}
                      onChange={(selectedOption) => formik.setFieldValue("jobType", selectedOption)}
                      onBlur={formik.handleBlur}
                      className={formik.touched.jobType && formik.errors.jobType ? 'is-invalid' : ''}
                    />
                    {formik.touched.jobType && formik.errors.jobType && (
                      <div className="text-danger ">
                        {formik.errors.jobType}
                      </div>
                    )}
                  </FormGroup>
                </Col>

                <Col md={3}>
                  <FormGroup>
                    <Label>Level <span className="text-danger">*</span></Label>
                    <CustomSelect
                      id="level"
                      name="level"
                      options={levelOptions}
                      value={formik.values.level || null}  // Store full object
                      onChange={(selectedOption) => formik.setFieldValue("level", selectedOption)}
                      onBlur={formik.handleBlur}
                      className={formik.touched.level && formik.errors.level ? 'is-invalid' : ''}
                    />
                    {formik.touched.level && formik.errors.level && (
                      <div className="text-danger ">
                        {formik.errors.level}
                      </div>
                    )}
                  </FormGroup>
                </Col>

              {formik.values.level?.value === 1 && (
                <Col md={3}>
                  <FormGroup>
                    <Label>Years <span className="text-danger">*</span></Label>
                    <div className="d-flex gap-2">
                      <Input
                        type="number"
                        placeholder="From"
                        name="yearsFrom"
                        value={formik.values.yearsFrom}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                      <Input
                        type="number"
                        placeholder="To"
                        name="yearsTo"
                        value={formik.values.yearsTo}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                    </div>
                    {formik.touched.yearsTo && formik.errors.yearsTo && (
                      <div className="text-danger ">
                        {formik.errors.yearsTo}
                      </div>
                    )}
                  </FormGroup>
                </Col>)}

                <Col className="pt-4 text-end mob-center">
                  <Button type="submit" className="btn button-save me-2 mt-2">
                    <i className="fas fa-save me-1" /> {isEdit ? "Update" : "Save"}
                  </Button>
                  <Button
                    type="button"
                    onClick={() => {
                      formik.handleReset();
                      setIsEdit(false);
                      setEditId(null);
                    }}
                    className="btn button-cancel mt-2"> <i className="fas fa-sync me-1" /> Cancel
                  </Button>
                </Col>
              </Row>
            </Form>
          </CardBody>
        </Card>

        <Card>
          <CardBody>
            <TableContainer
              columns={columns}
              data={requisitions && requisitions.length > 0 ? requisitions:[]}
              isGlobalFilter={true}
              customPageSize={10}
              className="custom-table"
            />
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default Requisition;
